export default __webpack_public_path__ + "static/media/179.46788aab.png";